// extracted by mini-css-extract-plugin
module.exports = {"main":"Banner_main__310xB","innerContainerFull":"Banner_innerContainerFull__3AccF","banner":"Banner_banner__5NfI4"};